export const parent = {
	visible: {
		y: 0,
		opacity: 1,
		transition: {
			when: 'beforeChildren',
			staggerChildren: 0.3,
		},
	},
	hidden: {
		y: 100,
		opacity: 0,
		transition: {
			when: 'afterChildren',
		},
	},
};

export const childern = {
	visible: { y: 0, opacity: 1, staggerChildern: 10 },
	hidden: { y: 15, opacity: 0 },
};

export const fade = {
	visible: {
		opacity: 1,
		transition: {
			when: 'beforeChildren',
			staggerChildren: 0.3,
			delay: 0.2,
		},
	},
	hidden: {
		opacity: 0,
		transition: {
			when: 'afterChildren',
		},
	},
};

export const aboutAnimations = {
	visible: {
		opacity: 1,
		transition: {
			delay: 0.2,
		},
	},
	hidden: {
		opacity: 0,
	},
};

export const experienceAnimations = {
	visible: {
		opacity: 1,
		transition: {
			when: 'beforeChildren',
			staggerChildren: 0.05,
		},
	},
	hidden: {
		opacity: 0,
	},
};

export const worksAnimations = {
	visible: {
		opacity: 1,
		transition: {
			when: 'beforeChildren',
			staggerChildren: 0.05,
		},
	},
	hidden: {
		opacity: 0,
	},
};
